import CartItem from '../Cart/cart-item';
import TariffsBundle from './tariffs-bundle';
import { CartItemTypes } from './../Cart/cart-item-types';
import { ActionResult, ErrorTypes, WpEventArgs } from './../Common';
import { ReservationItemTypes, ReservationItem } from './../Sale';
import * as moment from 'moment';
import { TariffSeance, TariffSale } from '.';
import Tariff from './tariff';
import TariffCapacity from './tariff-capacity';


export default class BundleCartItem extends CartItem {

    private _date: string = "";
    private _bundle: TariffsBundle;
    private _price: number = 0;
    private _type: CartItemTypes = CartItemTypes.Bundle;
    private _seance?: TariffSeance;
    private _sales: Array<TariffSale> = [];
    private _capacity: Array<TariffCapacity | undefined> = [];
    private _carNumbers?: Array<string>;

    get IsAvailable(): boolean {
        let notValidSale = this._sales.some(x => x.Quota != null && x.LeftCount != null && x.Count + x.ReservedCount < x.Quota);

        let notValidCapacity = this._capacity.some(x => x != null && x.Count + x.ReservedCount < x.Capacity);

        return !notValidSale && !notValidCapacity;
    }
    public get Info(): string {
        return `<strong>${this._bundle.Name}</strong>, ${this._date} ${this._seance != null ? TariffSeance.SeanceTime(this._seance) : ''}`;
    }
    public get Type(): CartItemTypes {
        return this._type;
    }
    public get Price(): number {
        return this._price;
    }
    public get Sales(): Array<TariffSale> {
        return this._sales;
    }
    public get Capacity(): Array<TariffCapacity | undefined> {
        return this._capacity;
    }
    get MetricsId(): any | undefined {
        return this._bundle?.Id;
    }
    /*
    public get Count(): number {
        return 1;
    }
    */
    public get IsCanIncreaseCount(): boolean {
        return false;
    }
    public get IsCanReduceCount(): boolean {
        return false;
    }
    public get Bundle(): TariffsBundle {
        return this._bundle;
    }
    public get Seance(): TariffSeance | undefined {
        return this._seance;
    }
    public get Date(): string {
        return this._date;
    }
    public get Count(): number {
        return this._bundle.Tariffs.length;
    }
    public get Dates(): Array<string> {
        let result = new Array<string>();

        if (this.Date !== undefined) {
            result.push(moment.parseZone(this.Date, 'YYYY-MM-DDTHH:mm').format('DD.MM.YYYY'));
        }

        return result;
    }
    public get AdditionalInfo(): any {
        return this._bundle;
    } 

    constructor(bundle: TariffsBundle, date: string, price: number, sales: Array<TariffSale>,
        capacity: Array<TariffCapacity | undefined>, seance?: TariffSeance,
        carNumbers?: Array<string>
        ) {
        super();

        this._date = date;
        this._bundle = bundle;
        this._price = price;
        this._seance = seance;
        this._sales = sales;
        this._capacity = capacity;
        this._carNumbers = carNumbers;

        this._capacity.forEach(x => {
            if (x != null) {
                x.ReservedCount++;
            }
        });

        this._sales.forEach(x => {
            if (x.Quota != null) {
                x.ReservedCount++;
            }
        });
    }

    public IncreaseCount(): ActionResult {
        return ActionResult.Failed(ErrorTypes.CartError, "Превышено допустимое количество для данного типа услуг");
    }

    public ReduceCount(): ActionResult {
        return ActionResult.Failed(ErrorTypes.CartError, "Достигнуто минимальное возможное количество");
    }

    public IsConflictItem(item: CartItem): boolean {
        return false;
    }

    public IsEqualsItem(item: CartItem): boolean {
        return false;
    }

    public CombineItem(item: CartItem): ActionResult {
        return ActionResult.Failed(ErrorTypes.CartError, "Превышено допустимое количество для данного типа услуг");
    }

    public GetReservationItem(): Array<ReservationItem> {
        let item = new ReservationItem(1, ReservationItemTypes.Bundle, null, this._date, this._bundle.Id, null, null, null, this._seance?.SeanceId);
        item.CarNumbers = this._carNumbers;
        return [item];
    }

    async RemoveItem(): Promise<ActionResult> {
        this._sales.forEach(x => {
            if (x.Quota != null) x.ReservedCount--;
        })

        this._capacity.forEach(x => {
            if (x != undefined) x.ReservedCount--;
        })

        return ActionResult.Success();
    }
}